import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'apnPipe'
})
export class ApnPipePipe implements PipeTransform {

  transform(value: string, serviceProvider: string): string {
    value = value.toLowerCase();
    if (value == "gmpvt" || value == "tcopvt") {
      value = "cn" + value
    }
    if (value == "hc internet") {
      return value;
    }
    if (serviceProvider.toLowerCase().includes("vodacom") && value.includes("connectnet")) {
      return value + ".net";
    } else {
      return value + ".co.za";
    }
  }

}
